const menuButton = document.querySelector('.menu-button');
const navLinks = document.querySelector('.nav-links');
if (menuButton && navLinks) {
  menuButton.addEventListener('click', () => {
    const open = navLinks.classList.toggle('open');
    menuButton.setAttribute('aria-expanded', String(open));
  });
  navLinks.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => {
    navLinks.classList.remove('open');
    menuButton.setAttribute('aria-expanded', 'false');
  }));
}

const startTrialSection = document.getElementById('start-trial');
if (startTrialSection) {
  const startTrialContactOptions = startTrialSection.querySelector('.contact-options');
  document.querySelectorAll('a[href="#start-trial"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (!window.matchMedia('(max-width: 940px)').matches) return;

      event.preventDefault();
      navLinks?.classList.remove('open');
      menuButton?.setAttribute('aria-expanded', 'false');

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          (startTrialContactOptions || startTrialSection).scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start',
          });
          window.history.pushState(null, '', '#start-trial');
        });
      });
    });
  });
}

document.querySelectorAll('[data-year]').forEach((el) => {
  el.textContent = new Date().getFullYear();
});

const emailContactButton = document.querySelector('[data-email-contact]');
if (emailContactButton) {
  emailContactButton.addEventListener('click', (event) => {
    const gmailWeb = emailContactButton.href;
    const gmailApp = emailContactButton.dataset.gmailApp;
    const mailto = emailContactButton.dataset.mailto;
    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    event.preventDefault();

    if (!isMobile) {
      const gmailWindow = window.open(gmailWeb, '_blank');
      if (gmailWindow) {
        gmailWindow.opener = null;
      } else {
        window.location.href = mailto;
      }
      return;
    }

    let fallbackTimer = window.setTimeout(() => {
      window.location.href = mailto;
    }, 1600);

    const stopFallback = () => {
      if (!document.hidden) return;
      window.clearTimeout(fallbackTimer);
      fallbackTimer = null;
      document.removeEventListener('visibilitychange', stopFallback);
    };

    document.addEventListener('visibilitychange', stopFallback);
    window.location.href = gmailApp;
  });
}

const copyEmailButton = document.querySelector('[data-copy-email]');
const copyStatus = document.querySelector('.copy-status');
if (copyEmailButton && copyStatus) {
  copyEmailButton.addEventListener('click', async () => {
    const email = copyEmailButton.dataset.copyEmail;
    try {
      await navigator.clipboard.writeText(email);
    } catch {
      const field = document.createElement('textarea');
      field.value = email;
      field.setAttribute('readonly', '');
      field.style.position = 'fixed';
      field.style.opacity = '0';
      document.body.appendChild(field);
      field.select();
      document.execCommand('copy');
      field.remove();
    }
    copyEmailButton.textContent = 'Email Copied';
    copyStatus.textContent = 'Copied: blue.superstar.hr@gmail.com';
    window.setTimeout(() => {
      copyEmailButton.textContent = 'Copy Email Address';
      copyStatus.textContent = '';
    }, 3500);
  });
}

const floatingContact = document.querySelector('[data-floating-contact]');
if (floatingContact) {
  const floatingContactToggle = floatingContact.querySelector('.floating-contact__toggle');
  const floatingContactPanel = floatingContact.querySelector('.floating-contact__panel');
  const floatingContactFirstLink = floatingContactPanel?.querySelector('a');

  const closeFloatingContact = (returnFocus = false) => {
    if (!floatingContactToggle || !floatingContactPanel || floatingContactPanel.hidden) return;
    floatingContactPanel.hidden = true;
    floatingContactToggle.setAttribute('aria-expanded', 'false');
    floatingContactToggle.setAttribute('aria-label', 'Open contact options');
    if (returnFocus) floatingContactToggle.focus();
  };

  floatingContactToggle?.addEventListener('click', () => {
    if (!floatingContactPanel) return;
    const willOpen = floatingContactPanel.hidden;
    floatingContactPanel.hidden = !willOpen;
    floatingContactToggle.setAttribute('aria-expanded', String(willOpen));
    floatingContactToggle.setAttribute('aria-label', willOpen ? 'Close contact options' : 'Open contact options');
    if (willOpen) floatingContactFirstLink?.focus();
  });

  document.addEventListener('click', (event) => {
    if (!floatingContact.contains(event.target)) closeFloatingContact();
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeFloatingContact(true);
  });
}



